// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Fy0H","left":"styles_left__OC4Rl"};